import store from '../../store'

const Main = (resolve) => {
  require.ensure(['./main'], () => {
    resolve(require('./main')) // eslint-disable-line global-require
  })
}

const Cart = (resolve) => {
  require.ensure(['./Cart'], () => {
    resolve(require('./Cart')) // eslint-disable-line global-require
  })
}

const Order = (resolve) => {
  require.ensure(['./Order'], () => {
    resolve(require('./Order')) // eslint-disable-line global-require
  })
}

const OrderConfirmation = (resolve) => {
  require.ensure(['./OrderConfirmation'], () => {
    resolve(require('./OrderConfirmation')) // eslint-disable-line global-require
  })
}

const Product = (resolve) => {
  require.ensure(['./product/Product'], () => {
    resolve(require('./product/Product')) // eslint-disable-line global-require
  })
}

const meta = {
  requiresAuth: true
}

const beforeEnter = (to, from, next) => {
  if (!store.getters.hasModuleCatering) {
    next({ path: '/' })
  }
  next()
}

export default [
  {
    name: 'catering',
    path: '/catering',
    component: Main,
    meta,
    beforeEnter,
  },
  {
    name: 'catering.cart',
    path: '/catering/cart',
    component: Cart,
    meta,
    beforeEnter,
  },
  {
    name: 'catering.order',
    path: '/catering/order',
    component: Order,
    meta,
    beforeEnter,
  },
  {
    name: 'catering.product',
    path: '/catering/product/:product_id',
    props: true,
    component: Product,
    meta,
    beforeEnter,
  },
  {
    name: 'catering.orderconfirmation',
    path: '/catering/orderconfirmation',
    component: OrderConfirmation,
    meta,
    beforeEnter,
  },
]



// WEBPACK FOOTER //
// ./src/app/singleorder/routes.js